module.exports = __webpack_public_path__ + "img/hx-yjybb.e8d6b646.svg";